module.exports = __webpack_public_path__ + "media/images/stars/2-6cb2fbe5e7dc2893bc440f27b8e5be0c.gif";